export const TIP_MIN_AMOUNT = 1
export const TIP_MAX_AMOUNT = 100
export const TIP_FEE_RATE = 0
